import { render, staticRenderFns } from "./GoThanks.vue?vue&type=template&id=7fe17c06&scoped=true"
import script from "./GoThanks.vue?vue&type=script&lang=js"
export * from "./GoThanks.vue?vue&type=script&lang=js"
import style0 from "./GoThanks.vue?vue&type=style&index=0&id=7fe17c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe17c06",
  null
  
)

export default component.exports